import React, { useEffect, useState } from 'react';
import Box from '@material-ui/core/Box';
import GridContainer from '../../../../@jumbo/components/GridContainer';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import AppSelectBox from '../../../../@jumbo/components/Common/formElements/AppSelectBox';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Autocomplete } from '@material-ui/lab';
import { ListItemText, MenuItem, TextField } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearCurrentMovieInfo,
  createDownload,
  getMovieList,
  resetMovieInfiteList,
  setCreatedDownload,
  setFilterType,
  updateDownload,
} from 'redux/actions/Movies';
import AppTextInput from '@jumbo/components/Common/formElements/AppTextInput';
import CmtAvatar from '@coremat/CmtAvatar';
import _ from 'lodash';
import { IS_DROPDOWN } from '@jumbo/constants/AppConstants';
import useDebounce from '@jumbo/utils/hooks/useDebounce/useDebounce';


const archiveOptions = [
  { archive: 'خیر', archiveKey: 'not_archived' || 0 },
  { archive: 'بله', archiveKey: 'archived' || 1 },
];

const downloadTypeOptions = [
  { downloadType: 'فیلم', downloadTypeId: 'movie' || 0 },
  { downloadType: 'مجموعه فیلم', downloadTypeId: 'movie_collection' || 1 },
  { downloadType: 'سریال', downloadTypeId: 'series' || 2 },
  { downloadType: 'مجموعه سریال', downloadTypeId: 'series_collection' || 3 },
];

const stateOptions = [
  { state: 'فعال', stateId: 0 },
  { state: 'غیرفعال', stateId: 1 },
  { state: 'بزودی', stateId: 2 },
];

const CreateDownloadFrom = ({ companies, movieInfo, movieUid, published }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { movieInfiniteList, filterType, metaMovieInfiniteList } = useSelector(({ movies }) => movies);

  const { id, download_type, is_archive, series, company, state, colleague_share_in_pay_off, company_share_in_pay_off } =
    movieInfo || {};

  const [colleaguePercentage, setColleaguePercentage] = useState(25);
  const [companyPercentage, setCompanyPercentage] = useState(65);
  const [downloadType, setDownloadType] = useState('');
  const [archiveKey, setArchiveKey] = useState('');
  const [companyId, setCompanyId] = useState('');
  const [seriesId, setSeriesId] = useState('');
  const [stateId, setStateId] = useState(published || 1);

  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const [seriesName, setSeriesName] = useState('');
  const debouncedSeriesName = useDebounce(seriesName, 500);

  useEffect(() => {
    if (movieInfo) {
      setColleaguePercentage(colleague_share_in_pay_off);
      setCompanyPercentage(company_share_in_pay_off);
      setDownloadType(download_type);
      setArchiveKey(is_archive);
      setCompanyId(company);
      setSeriesId(series);
      setStateId(state);
    }
  }, [movieInfo])

  useEffect(() => {
    dispatch(setFilterType({ by_name: debouncedSeriesName }));
  }, [debouncedSeriesName]);

  useEffect(() => {
    dispatch(getMovieList({ ...filterType, page: 1, per_page: 30, sorted: { column: 'submited_time', direction: 'asc' } }, IS_DROPDOWN));
    dispatch(resetMovieInfiteList())
    setHasMore(true)
  }, [filterType, dispatch]);

  useEffect(() => {
    return () => {
      if (history.action === 'POP') {
        dispatch(clearCurrentMovieInfo());
      }
    };
  }, [dispatch, history]);

  useEffect(() => {
    if (movieInfo) {
      dispatch(setCreatedDownload(true));
    } else {
      dispatch(setCreatedDownload(false));
    }
  }, [movieInfo, dispatch]);

  const handleSubmit = () => {
    const download = {
      movie_uid: movieUid,
      company_id: companyId?.id,
      download_type: downloadType,
      series_id: seriesId?.id,
      is_archive: archiveKey,
      state: stateId,
      company_share_in_pay_off: companyPercentage,
      colleague_share_in_pay_off: colleaguePercentage,
    };
    if (id) {
      dispatch(updateDownload({ download, id }));
    } else {
      dispatch(createDownload(download));
    }
  };

  const loadOptions = () => {
    if (loading || !hasMore) return;

    setLoading(true);

    try {
      const nextPageFilter = { ...filterType, page: filterType.page + 1 };
      dispatch(getMovieList({
        ...nextPageFilter,
        per_page: 30,
        sorted: { column: 'submited_time', direction: 'asc' }
      }, true));

      const moreOptionsAvailable = metaMovieInfiniteList?.total_pages > filterType.page + 1 ? true : false;
      setHasMore(moreOptionsAvailable);
    } catch (error) {
      console.error('Error loading options:', error);
    }

    setLoading(false);
  };


  const handleScroll = (event) => {
    const target = event.target;
    if (target.scrollHeight - target.scrollTop === target.clientHeight) {
      loadOptions();
    }
  };

  return (
    <React.Fragment>
      <GridContainer>
        <Grid item xs={12} sm={6}>
          <AppSelectBox
            fullWidth
            data={downloadTypeOptions}
            label="نوع دانلود"
            valueKey="downloadTypeId"
            variant="outlined"
            labelKey="downloadType"
            value={downloadType}
            onChange={e => setDownloadType(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <AppSelectBox
            fullWidth
            data={stateOptions}
            label="وضعیت انتشار"
            valueKey="stateId"
            variant="outlined"
            labelKey="state"
            value={stateId}
            onChange={e => setStateId(e.target.value)}
          />
        </Grid>
      </GridContainer>
      <GridContainer style={{ marginBottom: 12 }}>
        <Grid item xs={12} sm={6}>
          <AppSelectBox
            fullWidth
            data={archiveOptions}
            label="آرشیو"
            valueKey="archiveKey"
            variant="outlined"
            labelKey="archive"
            value={archiveKey}
            onChange={e => setArchiveKey(e.target.value)}
          />
        </Grid>
      </GridContainer>
      <GridContainer style={{ marginBottom: 12 }}>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            fullWidth
            id="combo-box-demo"
            options={companies}
            value={companyId}
            getOptionSelected={(option, value) => _.isEqual(option, value)}
            onChange={(event, value) => setCompanyId(value)}
            getOptionLabel={option => option.name || ''}
            renderInput={params => <TextField {...params} label="کمپانی" variant="outlined" />}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            fullWidth
            id="combo-box-series-id"
            options={movieInfiniteList}
            disableCloseOnSelect
            value={seriesId}
            loading={loading}
            getOptionSelected={(option, value) => _.isEqual(option, value)}
            onChange={(event, value) => setSeriesId(value)}
            onInputChange={(event, newInputValue) => setSeriesName(newInputValue)}
            getOptionLabel={option => option.name || ''}
            renderInput={params => <TextField {...params} label="نام فیلم یا سریال (اختیاری)" variant="outlined" />}
            renderOption={(props, option) => {
              return (
                <MenuItem {...props}>
                  <CmtAvatar size={40} src={props?.posters?.small} alt={props.name} variant="rounded" />
                  <ListItemText primary={props.name} style={{ marginRight: 7 }} />
                </MenuItem>
              );
            }}
            PopperComponent={(props) => <div {...props} onScroll={handleScroll} />}
          />
        </Grid>
      </GridContainer>
      <GridContainer style={{ marginBottom: 12 }}>
        <Grid item xs={12} sm={6}>
          <AppTextInput
            fullWidth
            type="number"
            variant="outlined"
            label="سهم همکارفروش"
            value={colleaguePercentage}
            onChange={e => {
              setColleaguePercentage(e.target.value);
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <AppTextInput
            fullWidth
            type="number"
            variant="outlined"
            label="سهم کمپانی"
            value={companyPercentage}
            onChange={e => {
              setCompanyPercentage(e.target.value);
            }}
          />
        </Grid>
      </GridContainer>
      <Box display="flex" justifyContent="flex-end" mb={4}>
        <Button href={'/movie'}>لغو</Button>
        <Box ml={2}>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            ثبت اطلاعات
          </Button>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default CreateDownloadFrom;

CreateDownloadFrom.prototype = {
  selectedContact: PropTypes.object,
};

CreateDownloadFrom.defaultProps = {
  selectedContact: null,
};
